@if (!initialized) {
    <!-- no content while loading, avoid potential flicker -->
} @else if (!isAdmin) {
    <p>{{ "set_int_no_admin_error_message" | translate }}</p>
} @else if (initialized) {
    @if (selectedIntegration) {
        <app-integration-details [integration]="selectedIntegration" (connected)="onConnect($event)" (disconnected)="onDisconnect($event)" />
    } @else {
        <div [class.opacity-40]="!currentUser?.isPro()" [class.grayscale]="!currentUser?.isPro()" [class.select-none]="!currentUser?.isPro()">
            <h2 class="center-page-heading">{{ "set_int_integrations_heading" | translate }}</h2>
            <p class="center-page-description">{{ "set_int_integrations_description" | translate }}</p>

            <p-iconfield class="w-160 max-w-[90%] mb-12">
                <p-inputicon>
                    <i class="pi pi-search"></i>
                </p-inputicon>

                <input
                    pInputText
                    type="text"
                    [(ngModel)]="searchTerm"
                    (input)="filterIntegrations()"
                    placeholder="{{ 'set_int_search_placeholder' | translate }}"
                    class="w-full"
                />
            </p-iconfield>

            @if (activeIntegrations.length > 0) {
                <h3 class="mt-12 tb-h5">{{ "set_int_active_integrations" | translate }}</h3>
                <div class="flex flex-wrap mb-2 -mx-4">
                    @for (integration of filteredActiveIntegrations; track integration.serviceId) {
                        <app-integration-card [integration]="integration" (cardClick)="openIntegrationDetails($event)" />
                    }
                </div>
            }

            <h3 class="mt-12 tb-h5">{{ "set_int_available_integrations" | translate }}</h3>

            <div class="flex flex-wrap mb-2 -mx-4">
                @for (integration of filteredAvailableIntegrations; track integration.serviceId) {
                    <app-integration-card [integration]="integration" (cardClick)="openIntegrationDetails($event)" />
                }
            </div>

            <div class="mt-12">
                {{ "set_int_integration_missing" | translate }}
                <a href="{{ 'set_int_integration_missing_link' | translate }}">{{ "set_int_integration_missing_link_text" | translate }}</a>
            </div>
        </div>
        @if (!currentUser?.isPro()) {
            <div class="absolute inset-0 z-50 flex mt-32 h-52 justify-center">
                <div class="mx-4 max-w-md rounded-xl bg-white dark:bg-zinc-800 p-8 text-center shadow-xl">
                    <h2 class="tb-h5">{{ "pro_account_needed_heading" | translate }}</h2>
                    <p class="mb-6">{{ "set_int_only_avail_with_pro_info" | translate }}</p>
                    <button pButton type="button" routerLink="/settings/store">
                        {{ "upgrade_now" | translate }}
                    </button>
                </div>
            </div>
        }
    }
}
